import React from 'react';
import { Text } from '@chakra-ui/react';
import { useReviewData } from 'src/contexts/ReviewDataProvider';
import { GenericSubmissionField } from './MySubmission/FormFieldGeneric/GenericSubmissionField';

const SubmissionFiles: React.FC<{isHeaderRequired?: boolean}> = ({ isHeaderRequired = true }  ) => {
  const { isReviewRequestAccepted } = useReviewData();

  return (
    <>
      {isReviewRequestAccepted() && isHeaderRequired && (
        <Text textStyle="headingGroup">Submission Files</Text>
      )}

      {isReviewRequestAccepted() && (
        <GenericSubmissionField
          entryPoint="review"
          fieldName="Manuscript"
          showSubtitle={false}
        />
      )}

      {isReviewRequestAccepted() && (
        <GenericSubmissionField
          entryPoint="review"
          fieldName="TitlePage"
          showSubtitle={false}
        />
      )}

      {isReviewRequestAccepted() && (
        <GenericSubmissionField
          entryPoint="review"
          fieldName="CompleteDocumentForReview"
          showSubtitle={false}
        />
      )}

      {isReviewRequestAccepted() && (
        <GenericSubmissionField
          entryPoint="review"
          fieldName="AnonymizedManuscript"
          showSubtitle={false}
        />
      )}

      {isReviewRequestAccepted() && (
        <GenericSubmissionField
          entryPoint="review"
          fieldName="Supplementary"
          showSubtitle={false}
        />
      )}
      {isReviewRequestAccepted() && (
        <GenericSubmissionField
          entryPoint="review"
          fieldName="AdditionalSupplementary"
          showSubtitle={false}
        />
      )}
      {isReviewRequestAccepted() && (
        <GenericSubmissionField entryPoint="review" fieldName="Figures" />
      )}
      {isReviewRequestAccepted() && (
        <GenericSubmissionField entryPoint="review" fieldName="Tables" />
      )}
    </>
  );
};

export default SubmissionFiles;
